<template>
  <el-table-column
    :label="$t('table.action')"
    :width="columnWidth"
    fixed="right"
    align="center"
  >
    <template #default="{ row }">
      <slot>
        <div class="button-group">
          <el-button
            v-if="isViewDetail"
            size="mini"
            icon="el-icon-view"
            circle
            @click="handleViewDetailButtonClick(row)"
          />
          <el-button
            v-if="isEdit"
            size="mini"
            type="warning"
            icon="el-icon-edit"
            circle
            @click="handleEditButtonClick(row)"
          />
          <el-button
            v-if="isDelete"
            size="mini"
            type="danger"
            icon="el-icon-delete"
            circle
            @click="handleDeleteButtonClick(row)"
          />
        </div>
      </slot>
    </template>
  </el-table-column>
</template>

<script>
import { createComponent, computed } from '@vue/composition-api'

const ActionColumn = createComponent({
  name: 'TableActionColumn',
  props: {
    width: {
      type: Number,
      default: 0,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    isDelete: {
      type: Boolean,
      default: false,
    },
    isViewDetail: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const columnWidth = computed(() => {
      if (props.width) return props.width
      const sumBool = (accumulator, currentValue) => accumulator + Number(currentValue)
      const numButtons = [props.isEdit, props.isDelete, props.isViewDetail].reduce(sumBool, 0)
      return (40 * numButtons) + 24
    })

    const handleEditButtonClick = (row) => {
      emit('edit', row)
    }
    const handleDeleteButtonClick = (row) => {
      emit('delete', row)
    }
    const handleViewDetailButtonClick = (row) => {
      emit('view-detail', row)
    }

    return {
      columnWidth,

      handleEditButtonClick,
      handleDeleteButtonClick,
      handleViewDetailButtonClick,
    }
  },
})

export default ActionColumn
</script>
